import { Link } from "react-router-dom";

/**
 * Brand mark for Ospino & Piñeres.
 * Stylized "OP" monogram in serif italic over a thin gold rule,
 * matching the brochure visual identity (gold + navy).
 */
export default function Logo({ variant = "dark", compact = false }) {
  const ink = variant === "light" ? "#FFFFFF" : "#0A192F";
  const gold = "#C5A059";
  const muted = variant === "light" ? "rgba(255,255,255,0.75)" : "#64748B";

  return (
    <Link
      to="/"
      data-testid="brand-logo"
      className="inline-flex items-center gap-3 group"
      aria-label="Ospino & Piñeres Abogados — Inicio"
    >
      <span
        className="font-serif italic leading-none"
        style={{
          color: ink,
          fontWeight: 600,
          fontSize: compact ? "26px" : "30px",
          letterSpacing: "-0.02em",
        }}
      >
        O<span style={{ color: gold }}>&</span>P
      </span>
      <span className="hidden sm:flex flex-col leading-tight">
        <span
          className="font-serif tracking-tight"
          style={{
            color: ink,
            fontSize: compact ? "13px" : "14px",
            fontWeight: 600,
            letterSpacing: "0.02em",
          }}
        >
          OSPINO &amp; PIÑERES
        </span>
        <span
          className="font-sans uppercase"
          style={{
            color: muted,
            fontSize: "9px",
            letterSpacing: "0.32em",
            marginTop: "2px",
          }}
        >
          Abogados &amp; Asociados
        </span>
      </span>
    </Link>
  );
}